



































import { Component, Vue } from "vue-property-decorator";
import { Button, Divider } from "vant";

@Component({
  components: {
    [Button.name]: Button,
    [Divider.name]: Divider
  }
})
export default class Index extends Vue {
  get riskText() {
    return this.$t("assessment.entry.riskText");
  }
  get btnText() {
    return this.$t("assessment.entry.btnText");
  }
}
